import styled from 'styled-components';

const ServiceStyle = styled.section`
	--distanceSlide: var(--gutter);
	--sizeArrow: var(--sp3x);
	--distanceArrow: var(--sp1x);
	--distanceTitleContent: var(--sp6x);
	--sizeSlid: calc((100% / 3) - var(--distanceSlide) * 2 / 3);

	.inner-wrapper-service {
		width: 100%;
		overflow: hidden;

		.swiper-horizontal {
			touch-action: pan-y;
		}

		.swiper-wrapper {
			display: flex;
			transition-property: transform;
		}

		.swiper {
			overflow: visible !important;
		}

		.swiper-slide {
			flex-shrink: 0;
			width: var(--sizeSlid);
			margin-right: var(--distanceSlide);

			&:last-child {
				margin-right: 0;
			}

			.inner-wrapper-slide {
				transition: calc(var(--trTime) * 1.4) ease-out calc(var(--delayItem) * 0.05s);
				height: 100%;
				transform: translateY(100%);
			}
		}
	}

	.wrapper-title-nav {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
		gap: var(--sp2x);
		margin-bottom: calc(var(--sectionDistance) / 2);

		.title-service-text {
			line-height: 1 !important;
		}

		.wrapper-navigation {
			display: flex;
			gap: var(--distanceArrow);
			opacity: 0;
			transition: var(--trTime) ease-in var(--trTime);

			.arrow {
				--iconSize: var(--sizeArrow);

				cursor: pointer;
			}
		}
	}

	&.active {
		.inner-wrapper-service {
			.swiper-slide {
				.inner-wrapper-slide {
					transform: translateY(0);
				}
			}
		}

		.wrapper-title-nav {
			.wrapper-navigation {
				opacity: 1;
			}
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.wrapper-title-nav {
				.wrapper-navigation {
					.arrow {
						&:hover {
							color: var(--hoverPrimaryColor);
						}
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeArrow: var(--sp3x);
		--distanceArrow: var(--sp1x);
		--distanceTitleContent: var(--sp4x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleContent: var(--sp3x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceArrow: var(--sp1x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceTitleContent: var(--sp2-5x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeArrow: var(--sp2-5x);
		--distanceArrow: var(--sp1x);
		--distanceTitleContent: var(--sp2x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeSlid: calc((100% / 2) - var(--distanceSlide) / 2);
		--sizeArrow: var(--sp2x);
		--distanceArrow: var(--sp0-5x);
		--distanceTitleContent: var(--sp2x);
	}
`;
export default ServiceStyle;
